// 半托管价格
import React, { useEffect } from 'react';

import PageStore from '@/stores/page';
import SemiStore from '@/stores/semi';

import MyLazyComponent from '@/common/lazy-load';

import logPrice from './log-price';
import SemiInfo from './semi-info';
import SemiList from './semi-list';

import './semi.less';

interface PropTypes {
  price: PriceTypes.Root;
  i18n: DetailTypes.i18n;
  moq: number;
  indexSelected?: number;
  logisticsSelected: PriceTypes.ShippingType;
  semiHosted: boolean;
  productId: number;
  discountText?: string;
  memberPriceDiscount?: {
    logo: string;
    text: string;
  };
  priceListWithLadderLogistic?: PriceTypes.PriceListWithLadderLogistic;
  quantityList: PriceTypes.QuantityListItem[];
  defaultLogisticsList: PriceTypes.ShippingType[];
  logisticsRequestIdList: PriceTypes.logisticsRequestIdItem[];
  recommendSaveTextMap: PriceTypes.RecommendSaveTextMap;
}

export default function Semi(props: PropTypes) {
  const {
    priceListWithLadderLogistic = [],
    //默认选择的价格档位
    indexSelected = 0,
    //默认选择的物流档位
    logisticsSelected,
    //价格档位列表
    quantityList = [],
    // 默认物流列表
    defaultLogisticsList,
    discountText,
    memberPriceDiscount,
    i18n,
    productId,
    logisticsRequestIdList,
    recommendSaveTextMap,
  } = props;
  if (priceListWithLadderLogistic.length === 0 || !logisticsSelected) return null;
  const { priceIndex = indexSelected } = SemiStore(state => state);
  const pageStore = PageStore(state => state);
  const { isLoaded } = pageStore;

  // 价格模块打点所需数据
  const handleLogParams = () => {
    if (!logisticsRequestIdList) return null;

    const logParams = defaultLogisticsList.map((item, index) => {
      return { ...priceListWithLadderLogistic[index][item], ...logisticsRequestIdList[index] };
    });
    return logParams;
  };

  useEffect(() => {
    // 全量数据校验打点
    const priceInfo = priceListWithLadderLogistic[priceIndex][logisticsSelected];
    logPrice(
      '/sc.detail_pc_halfdelegated_price_all',
      handleLogParams(),
      'EXP',
      `is_default_quality=true&productId=${productId}`
    );
    // 默认数据打点
    logPrice(
      '/sc.detail_pc_halfdelegated_price',
      priceInfo,
      'EXP',
      `is_default_quality=true&productId=${productId}&`
    );
  }, []);

  const SemiBalloon = MyLazyComponent(() => import('./semi-balloon'));

  return (
    <>
      <h4 className="semi-title">
        <span>
          {' '}
          {i18n['detail_pc_AG_price_guide']} {i18n['detail_pc_AG_price_included']}
        </span>{' '}
        {isLoaded && <SemiBalloon i18n={i18n} />}
      </h4>
      <div className="semi-price">
        <SemiList
          quantityList={quantityList}
          productId={productId}
          defaultIndex={indexSelected}
          recommendSaveTextMap={recommendSaveTextMap}
          priceListWithLadderLogistic={priceListWithLadderLogistic}
          indexSelected={priceIndex}
        />
        <SemiInfo
          indexSelected={priceIndex}
          productId={productId}
          defaultLogisticsList={defaultLogisticsList}
          priceListWithLadderLogistic={priceListWithLadderLogistic}
        >
          <>
            {discountText && (
              <div
                className="new-buyer"
                dangerouslySetInnerHTML={{
                  __html: discountText,
                }}
              ></div>
            )}
            {memberPriceDiscount?.logo && (
              <div className="discount">
                <img src={memberPriceDiscount.logo} />
                <span>{memberPriceDiscount.text}</span>
              </div>
            )}
          </>
        </SemiInfo>
      </div>
    </>
  );
}
